// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientEmailAddressModel {
    static getAttributeTypeMap() {
        return PatientEmailAddressModel.attributeTypeMap;
    }
}
PatientEmailAddressModel.discriminator = undefined;
PatientEmailAddressModel.additionalProperties = false;
PatientEmailAddressModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "PatientContactInformationPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=patientEmailAddressModel.js.map